import React, { useContext, useEffect, useState } from 'react';
import { ClientContext } from '../../../contexts/clientProvider';
import { UserContext } from '../../../contexts/userProvider';
import Visualizar from '../Visualizar';
import Servicos from '../Servicos';
import DataTable from '../../Table';
import Loader from '../../Loader/load';
import Equipamentos from '../Equipamentos';
import ItensTable from '../Itens';
import { formatCpfCnpj } from '../../General/Utils/formatCpfCnpj';

const Consulta = () => {
    const { clientes, loading, setAlert, deleteCliente } = useContext(ClientContext);
    const { isGerente } = useContext(UserContext);
    const [clients, setClients] = useState(null);
    const [clienteSelecionado, setClienteSelecionado] = useState(null);
    const [type, setType] = useState('');

    const componentes = {
        visualizar: <Visualizar cliente={clienteSelecionado} closeModal={closeModal} />,
        servicos: <Servicos closeModal={closeModal} clienteSelecionado={clienteSelecionado} />,
        equipamentos: <Equipamentos cliente={clienteSelecionado} closeModal={closeModal} />,
        itens: <ItensTable cliente={clienteSelecionado} closeModal={closeModal} />,
    }

    useEffect(() => {
        setClients(clientes || []);
    }, [clientes]);

    const headers = [
        {
            label: 'Nome',
            key: 'nome',
            sortable: true,
            width: 'w-1/4', // 25% da largura
            wrapText: true,
            truncate: true
        },
        {
            label: 'CPF/CNPJ',
            key: 'cpf_cnpj',
            sortable: false,
            width: 'w-1/6', // ~16% da largura
            render: (cliente) => formatCpfCnpj(cliente.cpf_cnpj)
        },
        {
            label: 'Tipo de Contrato',
            key: 'tipos_contratos',
            sortable: true,
            width: 'w-1/6', // ~16% da largura
            render: (cliente) => cliente.tipos_contratos || '—'
        },
        {
            label: 'Telefone',
            key: 'telefone',
            sortable: false,
            width: 'w-1/6' // ~16% da largura
        },
        {
            label: 'Serviços Prestados',
            key: 'servicos_prestados',
            sortable: false,
            width: 'w-1/5', // 20% da largura
            truncate: true
        },
        {
            label: 'Ações',
            key: 'actions',
            sortable: false,
            width: 'w-1/6', // ~16% da largura
            actions: {
                "visualizar": visualizarClient,
                "vincular": vincularServicosPrestados,
                "equipamentos": equipamentosClient,
                // Itens — restrito a gerente+ (nível 2 e 3), decisão de 15/set.
                ...(isGerente ? { "itens": itensClient } : {}),
                // "deletar": deleteClient,
            }
        },
    ];

    function visualizarClient(id) {
        const client = clients.find((client) => client.id === id);
        setClienteSelecionado(client);
        setType('visualizar');
    }

    function deleteClient(id) {
        if (!id) return console.error('ID não informado');
        setAlert({
            type: 'confirm',
            placeholder: 'Deseja realmente deletar o cliente?',
            visible: true,
            confirm: true,
            title: 'Atenção!',
            callback: () => deleteCliente(id),
            params: id
        })
    }

    function equipamentosClient(id) {
        setClienteSelecionado(id);
        setType('equipamentos');
    }

    function vincularServicosPrestados(id) {
        const client = clients.find((client) => client.id === id);
        setClienteSelecionado({ ...client });
        setType('servicos');
    }

    function itensClient(id) {
        setClienteSelecionado(id);
        setType('itens');
    }

    function closeModal() {
        setClienteSelecionado(null);
        setType('');
    }

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className="cliente-consulta-container">
                    {clients && <DataTable data={clients} headers={headers} itemsPerPage={5} />}
                    {type && componentes[type]}
                </div >
            )}
        </>
    );
};

export default Consulta;
